import React from "react";
import { Dialog } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useCurrentPortfolio } from "../../../../store";
import {
  SGridContainer,
  STitle,
  SDialogTitle,
  SDialogContent,
  SContent,
  SDialogActions,
  SManualBalanceButton,
  SAutoBalanceButton,
  SCloseButton,
  SCloseIcon,
  SEditIcon,
  SEqualIcon,
} from "./styles";
import { calculateAssetsTotalPercentage } from "../../../../utils";

interface PortfolioAlertProps {
  open: boolean;
  onClose: () => void;
}

export const PortfolioDialog: React.FC<PortfolioAlertProps> = ({
  open,
  onClose,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { balanceCurrentPortfolio, selectedPortfolio } = useCurrentPortfolio();

  const assetsTotalPercentage = calculateAssetsTotalPercentage(
    selectedPortfolio?.assets || null
  );

  const handleBalance = (): void => {
    balanceCurrentPortfolio();
    navigate("../analysis");
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        style: { borderRadius: 8 },
      }}
    >
      <SGridContainer>
        <SDialogTitle>
          <STitle>
            {assetsTotalPercentage} / 100 % {t("portfolioDialog.wallet")}
          </STitle>
          <SCloseButton onClick={onClose}>
            <SCloseIcon />
          </SCloseButton>
        </SDialogTitle>
        <SDialogContent>
          <SContent>{t("portfolioDialog.errorMessage")}</SContent>
        </SDialogContent>
        <SDialogActions>
          <SManualBalanceButton
            startIcon={<SEditIcon fontSize="small" />}
            onClick={onClose}
          >
            {t("portfolioDialog.manuallyAdjust")}
          </SManualBalanceButton>
          <SAutoBalanceButton
            onClick={handleBalance}
            startIcon={<SEqualIcon fontSize="small" />}
          >
            {t("portfolioDialog.equalShares")}
          </SAutoBalanceButton>
        </SDialogActions>
      </SGridContainer>
    </Dialog>
  );
};
